<div class="container">
  <form #form="ngForm">
    <div class="card">
      <div class="card-header card-title">Détail du bon à payer</div>
      <div class="card-body">
        <app-invoice-voucher-form [IsReadOnly]="!canUpdateVoucher" [InvoiceDetailModel]="invoiceDetailModel">
        </app-invoice-voucher-form>
      </div>
    </div>
    <app-invoice-traceability-workflows *ngIf="InvoiceTraceability" [InvoiceTraceability]="InvoiceTraceability">
    </app-invoice-traceability-workflows>
    <section class="section actions">
      <div class="row text-center justify-content">
        <div class="col">
          <button type="button" tooltip="Retour à l'écran de recherche"
            class="btn btn-secondary btn-sm btn-block actions" (click)="onBackToDetail()">Retour</button>
        </div>
        <div class="col" *ngIf="canUpdateVoucher">
          <button type="button" tooltip="Modifier le bon à payer" (click)="onSubmitVoucher()" [disabled]="!IsFormValid"
            class="btn btn-secondary btn-sm btn-block">Modifier</button>
        </div>
      </div>
    </section>
  </form>
</div>